import { lazier } from '@shared/components';

export const EditAdvancementReportPage = lazier(() =>
  import('./EditAdvancementReportPage'),
);
